import {DialogTitle} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

import {theme} from '../theme'

export default withStyles(
  {
    root: {
      position: 'relative',
      padding: theme.spacing(3, 3, 1.5),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(0, 2, 1),
      },
    },
  },
  {name: 'LPCDialogTitle'},
)(DialogTitle)
